const translations = {
    appTank: 'App Tank (gal)',
    carrier: 'Carrier',
    carrierLiquidFert: 'Liquid Fert',
    carrierRate: 'Rate gal/ac',
    carrierUan28: 'UAN 28',
    carrierUan32: 'UAN 32',
    carrierWater: 'Water',
    mixTank: 'Mix Tank (gal)',
    tankAndCarrier: 'Tank & Carrier'
};

export default translations;
